import React, { useMemo } from 'react';
import classnames from 'classnames';

import { Column } from 'components/Layouts/Flow';
import Icon from 'components/Icon';

const Message = ({ type, message }) => {
	// Generate message's classname based on type
	const cls = useMemo(() => classnames(
		'authorization__message',
		type === 'error' && 'authorization__message--error',
		type === 'success' && 'authorization__message--success',
	), [type]);

	// Render message only if message is present
	if (!message) return null;

	return (
		<Column size="12">
			<div className={cls}>
				<Icon icon={type === 'error' ? 'error_outline' : 'check'} size="lg" />
				{message}
			</div>
		</Column>
	);
};

export default Message;